/**
 * Sticky "Add to bag" button (snippets/sticky.liquid).
 * Adds the variant selected in the main picker through the main product form, so the cart drawer,
 * fly-to-cart and the Klaviyo waitlist (sold-out variant) behave exactly like the main button.
 * Opens the "pick a size" sheet only when no size is selected or there is no main form (bundles).
 */
class StickyAddToCart extends HTMLElement {
  /** @type {AbortController | undefined} */
  #controller;

  connectedCallback() {
    this.#controller = new AbortController();
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', this.handleClick, { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  get mainPicker() {
    return document.querySelector('variant-picker[data-template-product-match]');
  }

  get mainButton() {
    const button = document.querySelector('.product-details [data-testid="add-to-cart"]');
    return button instanceof HTMLButtonElement ? button : null;
  }

  get hasSelectedSize() {
    const picker = this.mainPicker;
    if (!picker) return false;
    const sizeGroup = picker.querySelector('[data-option-kind="size"]');
    if (!sizeGroup) return true; // Product without a size option
    if (sizeGroup.querySelector('input[type="radio"]:checked')) return true;
    const select = sizeGroup.querySelector('select');
    return select instanceof HTMLSelectElement && select.value !== '';
  }

  /** @param {MouseEvent} event */
  handleClick = (event) => {
    event.preventDefault();

    const mainButton = this.mainButton;
    if (mainButton && !mainButton.disabled && this.hasSelectedSize) {
      mainButton.click();
      return;
    }

    this.openSizeChart();
  };

  openSizeChart() {
    const selected = document.querySelector('input[name="color-sticky"]:checked');
    const sizeModal = document.getElementById('size-chart-modal');
    if (!sizeModal) return false;

    if (selected instanceof HTMLInputElement && 'updateSizesForColor' in sizeModal) {
      sizeModal.selectedColor = selected.value;
      sizeModal.updateSizesForColor(selected.value);
    }

    if ('open' in sizeModal && typeof sizeModal.open === 'function') {
      sizeModal.open();
    } else {
      sizeModal.style.display = 'block';
    }
    return true;
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
